module.exports = __webpack_public_path__ + "img/dsci0160.bb61fe60.jpg";